import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50 dark:bg-gray-950/40">
      <Card className="w-full max-w-md mx-4">
        <CardContent className="pt-6">
          <div className="flex mb-4 gap-2">
            <AlertCircle className="h-8 w-8 text-red-500" />
            <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-200">404 Page Not Found</h1>
          </div>

          <p className="mt-4 text-sm text-gray-600 dark:text-gray-400">
            This page may have moved, or the link may be incorrect.
          </p>
          <div className="flex gap-3 mt-5"><Button variant="outline" onClick={() => window.history.length > 1 ? window.history.back() : window.location.assign("/")}>Go back</Button><Button asChild><Link href="/">Dashboard</Link></Button></div>
        </CardContent>
      </Card>
    </div>
  );
}
